"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _personalRegisterActions = require("../personalregister/personalRegisterActions");
const usercustomReducers = {
  personalRegister: _personalRegisterActions.personalRegisterReducer
};
var _default = exports.default = usercustomReducers;